<template>
  <dialog :open="isOpen" class="default-dialog" @click="closeModal">
    <div class="dialog-content text-center p-4" @click.stop>
      <div class="icon-container mb-4">
        <div class="success-icon-circle">
          <i class="material-icons">verified_user</i>
        </div>
      </div>

      <h3 class="dialog-title mb-3">Segurança Ativada!</h3>

      <p class="text-secondary mb-4 px-3">
        Para sua total segurança, você será desconectado agora. 
        Por favor, realize o login novamente utilizando a nova verificação de dois fatores que você acabou de configurar.
      </p>

      <div class="button-field mt-4">
        <button
          @click="confirm"
          class="btn submit-button"
        >
          Entendi, vamos lá!
        </button>
      </div>
    </div>
  </dialog>
</template>

<script>
export default {
  name: "LogoutNotificationModal",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      // Logic doesn't allow closing without confirming usually, but let's emit for safety
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  background: none;
  backdrop-filter: blur(6px);
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s, transform 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}

.dialog-content {
  width: 400px;
  max-width: 90%;
  background: white;
  border-radius: 20px;
  padding: 30px;
  z-index: 2;
  transform: scale(0.9);
  transition: transform 0.3s;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.3);
}

dialog[open] .dialog-content {
  transform: scale(1);
}

.success-icon-circle {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #661cb0 0%, #a64bf4 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin: 0 auto;
  font-size: 40px;
  box-shadow: 0 10px 20px rgba(102, 28, 176, 0.3);

  i {
    font-size: 44px;
  }
}

.dialog-title {
  font-size: 24px;
  font-weight: 800;
  color: #344767;
}

.submit-button {
  background: linear-gradient(135deg, #661cb0 0%, #a64bf4 100%);
  color: white;
  border-radius: 12px;
  height: 52px;
  font-weight: 700;
  font-size: 16px;
  border: none;
  width: 100%;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(102, 28, 176, 0.4);
  }
}
</style>
